/* eslint-disable */
// import {
//   MQTTEventi_cassa,
//   MQTTProducts,
//   MQTTTable,
//   MQTTTags,
//   MQTTVariants,
//   MQTTWaiter
// } from "./mqtt_entities";

class MQTTEntity {
  name;
  identifier;
  client;
  _clientId;
  constructor(name, client, clientId) {
    this.name = name;
    this.client = client;
    this._clientId = clientId;
  }

  topic() {
    return [this._clientId, this.name].join("/");
  }

  /**
   * @param {string} clientId
   */
  _change(clientId) {
    this._clientId = clientId
  }
}

class MQTTCommand {
  _action;
  _entity;
  _code = "+";

  constructor(entity, action = "get") {
    this._entity = entity;
    this._action = action;
  }
  /**
   * Add a callback to the list of functions that will be called when the MQTT topic
   * related to this command is received.
   * @param {Function} callback - The callback to be called when the topic is received.
   * Will be called with the topic and the payload of the message as arguments.
   * @example
   *  mqtt.table.get.on((topic, payload) => {
   *    console.log(`Received GET on table ${topic}: ${payload}`);
   *  });
   */
  on(callback) {
    if (!listener[this._entity.name]) listener[this._entity.name] = {};
    if (!listener[this._entity.name][this._action])
      listener[this._entity.name][this._action] = [];
    listener[this._entity.name][this._action] = [
      ...listener[this._entity.name][this._action],
      callback
    ];
    console.log(listener[this._entity.name][this._action]);
  }
  popListener() {
    if (!listener[this._entity.name]) return;
    if (!listener[this._entity.name][this._action]) return;

    listener[this._entity.name][this._action].pop();
    console.log("NEW LISTENER", listener[this._entity.name][this._action]);
  }

  id(code) {
    if (code) this._code = code;
    return this;
  }

  _topic() {
    return `${this._entity.topic()}${this._action === "" ? "" : `/${this._action}`
      }`.toUpperCase();
  }

  publish(payload = "", level = { qos: 0, retain: true }) {
    let topic = this._topic();
    if (this._code != "+") {
      topic += `/${this._code}`;
    } else {
      topic += "/*";
    }

    this._entity.client.publish(topic, JSON.stringify(payload), level);
    this._code = "+";
  }
}

const listener = {};

class MQTTWaiter extends MQTTEntity {
  constructor(client, clientId) {
    super("WAITER", client, clientId);
  }

  state = new MQTTCommand(this, "STATE");
  assign = new MQTTCommand(this, "ASSIGN");
  error = new MQTTCommand(this, "ERROR");
}

class MQTTTable extends MQTTEntity {
  constructor(client, clientId) {
    super("TABLE", client, clientId);
  }

  state = new MQTTCommand(this, "STATE");
  change_step = new MQTTCommand(this, "CHANGE_STEP");
  error = new MQTTCommand(this, "ERROR");
}
class MQTTVariants extends MQTTEntity {
  constructor(client, clientId) {
    super("VARIANTS", client, clientId);
  }

  state = new MQTTCommand(this, "STATE");
}

class MQTTTags extends MQTTEntity {
  constructor(client, clientId) {
    super("TAGS", client, clientId);
  }

  state = new MQTTCommand(this, "STATE");
}

class MQTTProducts extends MQTTEntity {
  constructor(client, clientId) {
    super("PRODUCTS", client, clientId);
  }

  state = new MQTTCommand(this, "STATE");
}

class MQTTEventi_cassa extends MQTTEntity {
  constructor(client, clientId) {
    super("EVENTI_CASSA", client, clientId);
  }

  open = new MQTTCommand(this, "OPEN");
  close = new MQTTCommand(this, "CLOSE");
  pagamenti = new MQTTCommand(this, "PAGAMENTI");
  listini = new MQTTCommand(this, "LISTINI");
  error = new MQTTCommand(this, "ERROR");
}

class MQTTConfigurations extends MQTTEntity {
  constructor(client, clientId) {
    super("CONFIGURATIONS", client, clientId);
  }

  state = new MQTTCommand(this, "STATE");
  keyboard = new MQTTCommand(this, "KEYBOARD");
}

class MQTTNfc extends MQTTEntity {
  constructor(client, clientId) {
    super("NFC", client, clientId);
  }

  inserted = new MQTTCommand(this, "INSERTED");
  removed = new MQTTCommand(this, "REMOVED");
}

class Mqtt {
  client;
  clientId;
  globals = new Map();
  products = new MQTTProducts(null, "");
  table = new MQTTTable(null, "");
  waiter = new MQTTWaiter(null, "");
  tag = new MQTTTags(null, "");
  nfc = new MQTTNfc(null, "");
  variants = new MQTTVariants(null, "");
  events = new MQTTEventi_cassa(null, "");
  configurations = new MQTTConfigurations(null, "");
  constructor(client = null, clientId = "") {
    this.init(client, clientId);
  }
  init(client, clientId) {
    this.client = client;
    this.clientId = clientId;
    this._init(client, clientId);
  }

  receive(topic, message, packet) {
    const info = topic.split("/");
    if (info.length < 4) return;
    if (!listener[info[1]]) return;
    if (!listener[info[1]][info[2]]) return;
    listener[info[1]][info[2]].forEach(element => {
      element(info[3], message.toString("utf-8"));
    });
  }

  _init(client, clientId) {
    this.table = new MQTTTable(client, clientId);
    this.products = new MQTTProducts(client, clientId);
    this.waiter = new MQTTWaiter(client, clientId);
    this.tag = new MQTTTags(client, clientId);
    this.variants = new MQTTVariants(client, clientId);
    this.events = new MQTTEventi_cassa(client, clientId);
    this.configurations = new MQTTConfigurations(client, clientId);
    this.nfc = new MQTTNfc(client, clientId);
  }

  /**
  * @param {string} clientId
  */
  change(clientId) {
    this.table._change(clientId)
    this.products._change(clientId)
    this.waiter._change(clientId)
    this.tag._change(clientId)
    this.variants._change(clientId)
    this.events._change(clientId)
    this.configurations._change(clientId)
    this.nfc._change(clientId)
  }
}

const mqtt = new Mqtt(null, "");

export default mqtt;
export { MQTTCommand, MQTTEntity };
